export class Etablissement {
  id:number;
  nom:string;
  codeRNE:string;
  adresse1:string;
  adresse2:string;
  codePostal:string;
  ville:string;
  telephone:string;
  idPays:number;
  pays:string;
  indicNonQuantiteMinimale:boolean;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/etablissement.model.ts